import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Crosshair, Menu, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/marketplace", label: "Marketplace" },
    { to: "/#manifesto", label: "Manifesto" },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#1E070A]/80 border-b border-[#5A2A24]">
      <div data-testid="coming-soon-banner" className="w-full bg-[#C0894F] text-[#1E070A] overflow-hidden">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-1.5 flex items-center justify-center gap-3 font-mono text-[0.62rem] sm:text-[0.7rem] uppercase tracking-[0.22em] font-semibold text-center">
          <span className="live-dot !bg-[#1E070A] shrink-0" style={{ boxShadow: "none" }} />
          <span>Coming Soon — Shooter Bazaar isn't live yet. You're viewing an early preview.</span>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <Crosshair className="w-5 h-5 text-[#C0894F] transition-transform duration-300 group-hover:rotate-90" />
          <span className="font-display text-xl tracking-wide">SHOOTER <span className="text-[#C0894F]">BAZAAR</span></span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.to} href={l.to} data-testid={`nav-${l.label.toLowerCase()}`}
               className="mono-label hover:text-[#EFE4D2] transition-colors">{l.label}</a>
          ))}
          {user ? (
            <div className="flex items-center gap-4">
              <Link to="/dashboard" data-testid="nav-dashboard" className="mono-label hover:text-[#EFE4D2] transition-colors">Dashboard</Link>
              <button onClick={() => { logout(); nav("/"); }} data-testid="nav-logout" className="btn-ghost h-10">Logout</button>
            </div>
          ) : (
            <div className="flex items-center gap-3">
              <Link to="/auth" data-testid="nav-login" className="mono-label hover:text-[#EFE4D2] transition-colors">Login</Link>
              <Link to="/auth?mode=register" data-testid="nav-signup" className="btn-tactical h-10">Join</Link>
            </div>
          )}
        </nav>

        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#5A2A24] bg-[#1E070A] px-5 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a key={l.to} href={l.to} onClick={() => setOpen(false)} className="mono-label text-base">{l.label}</a>
          ))}
          {user ? (
            <>
              <Link to="/dashboard" onClick={() => setOpen(false)} className="mono-label text-base">Dashboard</Link>
              <button onClick={() => { logout(); nav("/"); setOpen(false); }} className="btn-ghost">Logout</button>
            </>
          ) : (
            <>
              <Link to="/auth" onClick={() => setOpen(false)} className="btn-ghost">Login</Link>
              <Link to="/auth?mode=register" onClick={() => setOpen(false)} className="btn-tactical">Join</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
